export default __webpack_public_path__ + "static/media/31.09699f11.png";